"use strict";
/* ========================================================================
    Module: Util
 ========================================================================== */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFillHeight = exports.getCssPropertyValue = void 0;
/*
 * Get CSS property value
 */
const getCssPropertyValue = (name) => {
    let value = getComputedStyle(document.documentElement).getPropertyValue(name);
    return value;
};
exports.getCssPropertyValue = getCssPropertyValue;
/*
 * 画面のサイズ変動があった時に高さを再計算する
 */
const setFillHeight = () => {
    const breakPointMedium = (0, exports.getCssPropertyValue)("--uk-breakpoint-l");
    const vh = window.innerHeight;
    let headerHeight = (0, exports.getCssPropertyValue)("--project-header-height-s");
    if (window.matchMedia(`(min-width: ${breakPointMedium})`).matches) {
        headerHeight = (0, exports.getCssPropertyValue)("--project-header-height-m");
    }
    document.documentElement.style.setProperty("--project-header-vh-s", `calc(${vh}px - ${headerHeight})`);
};
exports.setFillHeight = setFillHeight;
